import { useState } from 'react';
import { v4 as uuid } from 'uuid';

import * as api from 'api/methods';

export const useUpload = ({
  multiple,
  isCourseRequest,
  isLessonRequest,
  requestParams,
  value,
  helpers,
  onUploaded,
}: {
  multiple: any;
  isCourseRequest: any;
  isLessonRequest?: any;
  requestParams: any;
  value: any;
  helpers: any;
  onUploaded: any;
}) => {
  const [removeLoading, setRemoveLoading] = useState(false);
  const [percentage, setPercentage] = useState(0);

  const handleFileDialogOpen = () => {
    helpers.setTouched(true);
  };

  const handleDropAccepted = (files: any) => {
    if (!files.length) {
      return;
    }

    const currentFile = files[0];

    const fileId = uuid();

    if (multiple) {
      helpers.setValue([
        ...value,
        {
          id: fileId,
          name: currentFile.name,
          size: currentFile.size,
          type: currentFile.type,
          percentage: 0.1,
        },
      ]);
    } else {
      setPercentage(0.1);
    }

    const data = new FormData();
    data.append('file', currentFile);

    if (requestParams?.lessonId) {
      data.append('lessonId', requestParams.lessonId);
    }

    const config = {
      onUploadProgress: (progressEvent: any) => {
        const percentCompleted = Math.round(progressEvent.progress * 100);

        if (multiple) {
          const haveFile = value.some((file: any) => file.id === fileId);

          const nextFiles = haveFile
            ? value.map((file: any) => {
                if (file.id === fileId) {
                  return {
                    ...file,
                    percentage: percentCompleted,
                  };
                }

                return file;
              })
            : [
                ...value,
                {
                  id: fileId,
                  name: currentFile.name,
                  size: currentFile.size,
                  type: currentFile.type,
                  percentage: percentCompleted,
                },
              ];

          helpers.setValue(nextFiles);
        } else {
          setPercentage(percentCompleted);
        }
      },
    };

    const uploadPromise = isLessonRequest
      ? api.uploadLessonFile({ data, config }, requestParams)
      : isCourseRequest
        ? api.uploadCourseFile({ data, config }, requestParams)
        : api.uploadFile({ data, config });

    uploadPromise
      .then((response: any) => {
        const r = response as unknown as {
          path: string;
          name?: string;
          size?: number;
          type?: string;
        };
        if (multiple) {
          const haveFile = value.some((file: any) => file.id === fileId);

          const nextFiles = haveFile
            ? value.map((file: any) => {
                if (file.id === fileId) {
                  return {
                    ...file,
                    url: r.path,
                  };
                }

                return file;
              })
            : [
                ...value,
                {
                  id: fileId,
                  name: r.name,
                  size: r.size,
                  type: r.type,
                  url: r.path,
                  percentage: 100,
                },
              ];

          helpers.setValue(nextFiles);
        } else {
          setPercentage(0);

          helpers.setValue(r.path);
        }

        if (onUploaded) {
          onUploaded(r);
        }
      })
      .catch(() => {});
  };

  const handleDropRejected = (event: any) => {
    const eventError = event[0].errors[0];

    switch (eventError.code) {
      // case EVENT_ERROR_CODE.INVALID_TYPE: {
      //   form.setFieldError(
      //     field.name,
      //     'The specified file could not be uploaded. Allowed type jpeg, png, gif, avi, mp4, mov, mkv, mpg, wmv, mts, 3gp',
      //   );

      //   break;
      // }
      // case EVENT_ERROR_CODE.LARGE_SIZE: {
      //   form.setFieldError(field.name, eventError.message);

      //   break;
      // }
      // case EVENT_ERROR_CODE.MANY_FILES: {
      //   form.setFieldError(field.name, 'No more than 3 files can be attached');

      //   break;
      // }

      default: {
        helpers.setError(eventError.message);

        break;
      }
    }
  };

  const handleRemoveClick = (fileId: string) => {
    let fileToRemove = null;

    if (multiple) {
      fileToRemove = value.find((file: any) => file.id === fileId);
    } else {
      fileToRemove = { url: value };
    }

    const filePath = fileToRemove.url.substring(1);

    setRemoveLoading(true);

    api
      .removeFile({ path: filePath })
      .then(() => {
        setRemoveLoading(false);

        if (multiple) {
          helpers.setValue([]);
        } else {
          helpers.setValue('');
        }
      })
      .catch(() => {
        setRemoveLoading(false);
      });
  };

  return [
    removeLoading,
    percentage,
    handleFileDialogOpen,
    handleDropAccepted,
    handleDropRejected,
    handleRemoveClick,
  ];
};
